import * as Data from '../api/archibus-v2/DataApi'

export const fetchServiceRequests = ({emId, numberOfRecords = 1000}) => {
  let restriction = new Ab.view.Restriction()
  restriction.addClause('activity_log.requestor', emId)

  return Data.getPagedDataFromDataSource(
    'ab-selfservice-dashboard.axvw',
    'serviceRequests',
    restriction,
    [],
    1,
    numberOfRecords
  ).catch(err => {
    console.log(err)
  })
}

export const fetchActivityTypes = () => {
  return Data.getDataFromDataSource(
    'ab-self-service.axvw',
    'activityTypes'
  ).then(result => {
    const {data} = result
    let activityTypes = data.map(type => ({
      value: type.activityTypeNl || type.activityType,
      label: type.descriptionFormat
    }))

    return Promise.resolve(activityTypes)
  })
}

export const getServiceRequestVisibleFields = hideFields => {
  if (hideFields) {
    const hideFieldsList = hideFields.split(';')
    return {
      hasLocation:
        !hideFieldsList.includes('bl_id') &&
        !hideFieldsList.includes('fl_id') &&
        !hideFieldsList.includes('rm_id'),
      hasEquipment: !hideFieldsList.includes('eq_id'),
      hasSpecificLocation: !hideFieldsList.includes('location'),
      hasDoc1: !hideFieldsList.includes('doc1'),
      hasDoc2: !hideFieldsList.includes('doc2'),
      hasDoc3: !hideFieldsList.includes('doc3'),
      hasDoc4: !hideFieldsList.includes('doc4')
    }
  } else {
    return {
      hasLocation: true,
      hasEquipment: true,
      hasSpecificLocation: true,
      hasDoc1: true,
      hasDoc2: true,
      hasDoc3: true,
      hasDoc4: true
    }
  }
}
